export default (e) => {
  if (e && e.target) {
    e.stopPropagation();
    e.target.closest(".collapsible").classList.toggle("is-open");
  }
};
